import { ABTestCases, ABTestConfig } from './types';

export const defaultValues: ABTestCases = {
  SORTING_INDICE: 'default',
  PRODUCT_LIST_HITS_PER_PAGE: 192,
  STICKY_HEADER: false,
  PRODUCTS_PERSONALIZATION_PROVIDER: 'none',
  NORMAL_PRODUCTS_BETWEEN_DY_PRODUCTS: 0,
  IMAGE_CDN_PROVIDER: 'cloudflare',
  NO_PRODUCT_TILE_WISHLIST_TEXT: false,
  SHOW_MAGNIFYING_GLASS: false,
};

export const FALLBACK_ABTEST_VALUES: ABTestConfig = {
  config: defaultValues,
  title: 'ab_test_default_no_abtest',
  variant: 'no_ab_test_default_variant',
  trafficSlotNumber: 0,
};
